import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    title: "Luxury collection",
    item: "Apple Ultra",
    price: 90000,
    discounted_price: 80000,
    brand: "apple",
    Category: "Luxury",
    img: "https://store.storeimages.cdn-apple.com/4668/as-images.apple.com/is/MQDY3ref_VW_34FR+watch-49-titanium-ultra_VW_34FR_WF_CO+watch-face-49-alpine-ultra_VW_34FR_WF_CO_GEO_IN?wid=1400&hei=1400&trim=1%2C0&fmt=p-jpg&qlt=95&.v=1683224241054",
    color: "Blue",
    tag:"Trending", 
    availability: "cash-on-delivery",
    gender: "Male",
    ratings: 5, 
    use: "stylish"
  },
  {
    _id: uuid(),
    title: "Analogs",
    item: "Blue Dial Leather Analog Watch - FS5960I",
    price: 10000,
    discounted_price: 4000,
    brand: "Fossil",
    Category: "Casual",
    img: "https://sslimages.shoppersstop.com/sys-master/images/h4e/hc2/28747031019550/WFIFFS5960I_NoColour.jpg_2000Wx3000H",
    color: "Blue",
    tag:"Selling fast",
    availability: "cash-on-delivery",
    gender: "Male",
    ratings: 4.8,
    use: "workwear"
  },
  {
    _id: uuid(),
    title: "Smart fit collection",
    item: "Titan Smart 2",
    price: 15000,
    discounted_price: 5000,
    brand: "Titan",
    Category:"Smartwatch",
    img: "https://m.media-amazon.com/images/I/61rS5cBxH6L._UX522_.jpg",
    color: "green",
    tag:"New",
    availability: "cash-on-delivery",
    gender: "Male",
    ratings: 4.7,
    use: "fitness"
  },
   {
    _id: uuid(),
    title: "Smart fit collection",
    item: "Titan Smart 2",
    price: 15000,
    discounted_price: 7000,
    brand: "Titan",
    Category:"Smartwatch",
    img: "https://m.media-amazon.com/images/I/61yMogr0zSL._UX522_.jpg",
    color: "black",
    tag:"Trending",
    availability: "cash-on-delivery",
    gender: "Male",
    ratings: 5,
    use: "fitness"
  },
   {
    _id: uuid(),
    title: "Fastrack Wearables",
    item: "Reflex Vox Carbon Black Dial Silicone Smart Watch",
    price: 8000,
    discounted_price: 5000,
    brand: "First track",
    Category:"Smartwatch",
    img: "https://sslimages.shoppersstop.com/sys-master/images/hd8/h19/26908966682654/WFT38072AP01_NoColour.jpg_2000Wx3000H",
    color: "black",
    tag:"Trending",
    availability: "one-day-delivery",
    gender: "Female",
    ratings: 4.5,
    use: "stylish"
  },
  {
    _id: uuid(),
    title: "Fastrack Wearables",
    item: "Reflex Vox Champagne Pink Dial Silicone Smart Watch",
    price: 7000,
    discounted_price: 5000,
    brand: "First track",
    Category:"Smartwatch",
    img: "https://sslimages.shoppersstop.com/sys-master/images/h74/h76/26908957900830/WFT38072AP03_NoColour.jpg_2000Wx3000H",
    color: "pink",
    tag:"Trending",
    availability: "one-day-delivery",
    gender: "Male",
    ratings: 4,
    use: "casual"
  },
    {
    _id: uuid(),
    title: "Analog",
    item: "White Dial Silicone Multi-Function",
    price: 14000,
    discounted_price: 8000,
    brand: "Tommy Hilfiger",
    Category:"Casual",
    img: "https://sslimages.shoppersstop.com/sys-master/images/h57/h08/28707894099998/WTONDTH1791778_NoColour.jpg_2000Wx3000H",
    color: "Blue",
    tag:"New",
    availability: "one-day-delivery",
    gender: "Female",
    ratings: 4.6,
    use: "stylish"
  },
    {
    _id: uuid(),
    title: "Fastrack Wearables",
    item: "Reflex Curv Pink Strap Silicone Digital Watch",
    price: 25000,
    discounted_price: 15000,
    brand: "Fossil",
    Category:"Smartwatch",
    img: "https://sslimages.shoppersstop.com/sys-master/images/h86/haa/26734120828958/WFIF-FTW6077_NoColour.jpg_2000Wx3000H",
    color: "Golden",
    tag:"Selling fast",
    availability: "one-day-delivery",
    gender: "Male",
    ratings: 5,
    use: "stylish"
  },
  {
    _id: uuid(),
    title: "Fastrack Wearables",
    item: "Gen 6 Full Color Display Stainless Steel Digital Smart Watch",
    price: 10000,
    discounted_price: 5000,
    brand: "First track",
    Category:"Smartwatch",
    img: "https://sslimages.shoppersstop.com/sys-master/images/h0c/hd5/27614754734110/WFT38073AP03_NoColour.jpg_2000Wx3000H",
    color: "pink",
    tag:"New",
    gender: "Female",
    availability: "one-day-delivery",
    ratings: 4,
    use: "fitness"
  },
  {
    _id: uuid(),
    title: "G-Shock",
    item: "Analog Digital Watch for Men",
    price: 35000,
    discounted_price: 30000,
    brand: "Casio",
    Category:"Luxury",
    img: "https://rukminim1.flixcart.com/image/832/832/ku4ezrk0/watch/r/m/m/g1159-gm-2100-1adr-casio-men-original-imag7b2efczs8g9h.jpeg?q=70",
    color: "pink",
    tag:"Selling fast",
    availability: "one-day-delivery",
    gender: "Male",
    ratings: 3.5
  },
   {
    _id: uuid(),
    title: "Daily wear",
    item: "The minimalist analog watch for men",
    price: 10000,
    discounted_price: 6000,
    brand: "Fossil",
    Category:"Casual",
    img: "https://fossil.scene7.com/is/image/FossilPartners/FS5841_main?$sfcc_fos_hi-res$",
    color: "brown",
    tag:"Huge Discount",
    availability: "one-day-delivery",
    gender: "Male",
    ratings: 3.5
  },
   {
    _id: uuid(),
    title: "G-Shock",
    item: "Analog Digital Watch for Women",
    price: 10000,
    discounted_price: 9000,
    brand: "Casio",
    Category:"Luxury",
    img: "https://cdn.shopify.com/s/files/1/0068/6712/4282/products/unnamed_dbf0ad86-99f5-40b6-9b65-f7dca3ac921c_grande.jpg?v=1624941464",
    color: "pink",
    tag:"Huge Discount",
    availability: "cash-on-delivery",
    gender: "Female",
    ratings: 3
  },
  {
    _id: uuid(),
    title: "Daily wear",
    item: "Cami analog watch for women",
    price: 10000,
    discounted_price: 7500,
    brand: "Tommy Hilfinger",
    Category:"Casual",
    img: "https://m.media-amazon.com/images/I/71nGcwHyaSL._UY679_.jpg",
    color: "pink",
    availability: "one-day-delivery",
    gender: "Female",
    ratings: 3
  },
   {
    _id: uuid(),
    title: "Fossil",
    item: " Scarlette Analog Watch for Women",
    price: 10000,
    discounted_price: 5500,
    brand: "Fossil",
    Category:"Luxury",
    img: "https://m.media-amazon.com/images/I/51B8fewjzIL._UX522_.jpg",
    color: "pink",
    availability: "cash-on-delivery",
    gender: "Female",
    ratings: 2.5
  },

  {
    _id: uuid(),
    title: "Daily wear",
    item: "Neo splash analog watch for men",
    price: 10000,
    discounted_price: 9000,
    brand: "Titan",
    Category:"Smartwatch",
    img: "https://staticimg.titan.co.in/Titan/Catalog/90142QM01_1.jpg?impolicy=pqmed&imwidth=640",
    color: "blue",
    availability: "cash-on-delivery",
    gender: "Male",
    ratings: 2.5
  },
   {
    _id: uuid(),
    title: "Apple",
    item: "Midnight alluminium brand with midnight sport brand",
    price: 30000,
    discounted_price: 25000,
    brand: "Apple",
    Category:"Smartwatch",
    img: "https://m.media-amazon.com/images/I/51B8fewjzIL._UX522_.jpg",
    color: "black",
    gender: "Male",
    ratings: 2.7
  },

  {
    _id: uuid(),
    title: "Apple",
    item: "Midnight alluminium brand with midnight sport brand",
    price: 30000,
    discounted_price: 25000,
    brand: "Apple",
    Category:"Smartwatch",
    img: "https://m.media-amazon.com/images/I/71LfnkRgZ4L._SX679_.jpg",
    color: "black",
    gender: "Male",
    ratings: 3.5
  },

  {
    _id: uuid(),
    title: "Samsung",
    item: "4 LTE Smartwatch (Android only)",
    price: 35000,
    discounted_price: 15000,
    brand: "Samsung",
    Category:"Smartwatch",
    img: "https://images.samsung.com/is/image/samsung/p6pim/in/2108/gallery/in-galaxy-watch4-398887-sm-r875fzkainu-481111543?$1300_1038_PNG$",
    color: "black",
    gender: "Female",
    ratings: 4
  },
];
